import React from 'react'

const ratio = 123 / 51
export default function BluePinkDarkTiles({ className = undefined, height = 51 }) {
  return (
    <svg
      id="e6UxA3eE01w1"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 123 51"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      width={height * ratio}
      height={height}
    >
      <g transform="translate(42.470001 0)">
        <polygon
          id="e6UxA3eE01w5"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(-.244845 0)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w7"
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w8"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="e6UxA3eE01w10"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="e6UxA3eE01w11"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w12"
            points="36.6,10.5 36.6,7.5 19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(63.703999 8.148)">
        <polygon
          id="e6UxA3eE01w14"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w16"
            points="2.3,10.8 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w17"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="e6UxA3eE01w19"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="e6UxA3eE01w20"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w21"
            points="19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7 36.6,10.5 36.6,7.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(21.235001 8.148)">
        <polygon
          id="e6UxA3eE01w23"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.117367 0.153839)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w25"
            points="2.4,10.9 19,4.7 35.6,10.9"
            transform="translate(.117367 0)"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w26"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="e6UxA3eE01w28"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="e6UxA3eE01w29"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w30"
            points="22.7,2.4 19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7 36.6,10.5 36.6,8.3 36.6,7.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(84.938004 16.296)">
        <polygon
          id="e6UxA3eE01w32"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w34"
            points="2.4,10.9 19,4.7 36.6,11.2"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w35"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="e6UxA3eE01w37"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(0-.127478)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="e6UxA3eE01w38"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w39"
            points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 15.3,16.4 15.3,15.7 1.5,10.5"
            transform="translate(-.127479 0)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(42.420002 16.296)">
        <polygon
          id="e6UxA3eE01w41"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.127478 0)"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w43"
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w44"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="e6UxA3eE01w46"
            points="1.5,7.5 19,14.1 36.6,7.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="e6UxA3eE01w47"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w48"
            points="1.5,7.5 19,1 36.6,7.5 36.6,10.5 22.7,15.7 22.7,16.4 19.7,17.5 19,17.3 18.4,17.5 15.3,16.4 15.3,15.7 1.5,10.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(0 16.296)">
        <polygon
          id="e6UxA3eE01w50"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w52"
            points="1.5,11.2 1.5,11.2 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w53"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="e6UxA3eE01w55"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(.127479 0)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="e6UxA3eE01w56"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w57"
            points="1.5,7.5 19,1 36.6,7.5 36.6,10.5 22.7,15.7 22.7,16.4 19,17.8 1.5,11.2"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(63.703999 24.444)">
        <polygon
          id="e6UxA3eE01w59"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(0 0.127479)"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w61"
            points="2.3,10.8 19,4.7 36.6,11.2"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w62"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="e6UxA3eE01w64"
            points="1.5,7.6 19,14.1 36.6,7.6"
            transform="translate(0-.127478)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <line
            id="e6UxA3eE01w65"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w66"
            points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 15.3,16.4 15.3,15.7 1.5,10.5"
            transform="translate(.117367 0)"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(21.235001 24.444)">
        <polygon
          id="e6UxA3eE01w68"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.127479 0)"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w70"
            points="1.5,11.2 1.5,11.2 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w71"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <polyline
            id="e6UxA3eE01w73"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="e6UxA3eE01w74"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w75"
            points="1.5,7.6 19,1 36.6,7.6 36.6,10.5 22.7,15.7 22.7,16.4 19,17.8 1.5,11.2"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(42.470001 32.592999)">
        <polygon
          id="e6UxA3eE01w77"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="#00abe8"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            id="e6UxA3eE01w79"
            points="1.5,11.2 1.5,11.2 19,4.7 36.6,11.2"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line
            id="e6UxA3eE01w80"
            x1="19"
            y1="1"
            x2="19"
            y2="4.7"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <line
            id="e6UxA3eE01w82"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polyline
            id="e6UxA3eE01w83"
            points="1.5,7.5 19,14.1 36.6,7.5"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
          <polygon
            id="e6UxA3eE01w84"
            points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
            fill="none"
            stroke="#82d4f2"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <style>
        {`#e6UxA3eE01w5 {animation: e6UxA3eE01w5_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w5_f_p { 0% {fill: none} 29.166667% {fill: none} 33.333333% {fill: #d82071} 45.833333% {fill: #d82071} 50% {fill: none} 79.166667% {fill: none} 83.333333% {fill: #00abe8} 91.666667% {fill: #00abe8} 95.833333% {fill: #00abe8} 100% {fill: none}} #e6UxA3eE01w7 {animation: e6UxA3eE01w7_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w7_s_p { 0% {stroke: #005992} 29.166667% {stroke: #005992} 33.333333% {stroke: #760033} 79.166667% {stroke: #760033} 83.333333% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w8 {animation: e6UxA3eE01w8_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w8_s_p { 0% {stroke: #005992} 29.166667% {stroke: #005992} 33.333333% {stroke: #760033} 79.166667% {stroke: #760033} 83.333333% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w10 {animation: e6UxA3eE01w10_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w10_s_p { 0% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w11 {animation: e6UxA3eE01w11_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w11_s_p { 0% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w12 {animation: e6UxA3eE01w12_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w12_s_p { 0% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w14 {animation: e6UxA3eE01w14_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w14_f_p { 0% {fill: #00abe8} 4.166667% {fill: #00abe8} 8.333333% {fill: none} 29.166667% {fill: none} 33.333333% {fill: #d82071} 45.833333% {fill: #d82071} 50% {fill: none} 87.5% {fill: none} 91.666667% {fill: #00abe8} 100% {fill: #00abe8}} #e6UxA3eE01w16 {animation: e6UxA3eE01w16_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w16_s_p { 0% {stroke: #005992} 29.166667% {stroke: #005992} 33.333333% {stroke: #760033} 87.5% {stroke: #760033} 91.666667% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w17 {animation: e6UxA3eE01w17_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w17_s_p { 0% {stroke: #005992} 29.166667% {stroke: #005992} 33.333333% {stroke: #760033} 87.5% {stroke: #760033} 91.666667% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w19 {animation: e6UxA3eE01w19_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w19_s_p { 0% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w20 {animation: e6UxA3eE01w20_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w20_s_p { 0% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w21 {animation: e6UxA3eE01w21_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w21_s_p { 0% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w23 {animation: e6UxA3eE01w23_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w23_f_p { 0% {fill: none} 37.5% {fill: none} 41.666667% {fill: #d82071} 54.166667% {fill: #d82071} 58.333333% {fill: none} 79.166667% {fill: none} 83.333333% {fill: #00abe8} 91.666667% {fill: #00abe8} 95.833333% {fill: #00abe8} 100% {fill: none}} #e6UxA3eE01w25 {animation: e6UxA3eE01w25_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w25_s_p { 0% {stroke: #005992} 37.5% {stroke: #005992} 41.666667% {stroke: #760033} 79.166667% {stroke: #760033} 83.333333% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w26 {animation: e6UxA3eE01w26_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w26_s_p { 0% {stroke: #005992} 37.5% {stroke: #005992} 41.666667% {stroke: #760033} 79.166667% {stroke: #760033} 83.333333% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w28 {animation: e6UxA3eE01w28_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w28_s_p { 0% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w29 {animation: e6UxA3eE01w29_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w29_s_p { 0% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w30 {animation: e6UxA3eE01w30_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w30_s_p { 0% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w32 {animation: e6UxA3eE01w32_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w32_f_p { 0% {fill: #00abe8} 12.5% {fill: #00abe8} 16.666667% {fill: none} 29.166667% {fill: none} 33.333333% {fill: #d82071} 45.833333% {fill: #d82071} 50% {fill: none} 91.666667% {fill: none} 95.833333% {fill: none} 100% {fill: #00abe8}} #e6UxA3eE01w34 {animation: e6UxA3eE01w34_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w34_s_p { 0% {stroke: #005992} 29.166667% {stroke: #005992} 33.333333% {stroke: #760033} 91.666667% {stroke: #760033} 95.833333% {stroke: #760033} 100% {stroke: #005992}} #e6UxA3eE01w35 {animation: e6UxA3eE01w35_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w35_s_p { 0% {stroke: #005992} 29.166667% {stroke: #005992} 33.333333% {stroke: #760033} 91.666667% {stroke: #760033} 95.833333% {stroke: #760033} 100% {stroke: #005992}} #e6UxA3eE01w37 {animation: e6UxA3eE01w37_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w37_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}} #e6UxA3eE01w38 {animation: e6UxA3eE01w38_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w38_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}} #e6UxA3eE01w39 {animation: e6UxA3eE01w39_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w39_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 29.166667% {stroke: #00abe8} 33.333333% {stroke: #f26aa6} 37.5% {stroke: #f26aa6} 41.666667% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}} #e6UxA3eE01w41 {animation: e6UxA3eE01w41_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w41_f_p { 0% {fill: #00abe8} 4.166667% {fill: #00abe8} 8.333333% {fill: none} 37.5% {fill: none} 41.666667% {fill: #d82071} 54.166667% {fill: #d82071} 58.333333% {fill: none} 87.5% {fill: none} 91.666667% {fill: #00abe8} 100% {fill: #00abe8}} #e6UxA3eE01w43 {animation: e6UxA3eE01w43_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w43_s_p { 0% {stroke: #005992} 37.5% {stroke: #005992} 41.666667% {stroke: #760033} 87.5% {stroke: #760033} 91.666667% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w44 {animation: e6UxA3eE01w44_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w44_s_p { 0% {stroke: #005992} 37.5% {stroke: #005992} 41.666667% {stroke: #760033} 87.5% {stroke: #760033} 91.666667% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w46 {animation: e6UxA3eE01w46_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w46_s_p { 0% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w47 {animation: e6UxA3eE01w47_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w47_s_p { 0% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w48 {animation: e6UxA3eE01w48_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w48_s_p { 0% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w50 {animation: e6UxA3eE01w50_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w50_f_p { 0% {fill: none} 45.833333% {fill: none} 50% {fill: #d82071} 62.5% {fill: #d82071} 66.666667% {fill: none} 79.166667% {fill: none} 83.333333% {fill: #00abe8} 91.666667% {fill: #00abe8} 95.833333% {fill: #00abe8} 100% {fill: none}} #e6UxA3eE01w52 {animation: e6UxA3eE01w52_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w52_s_p { 0% {stroke: #005992} 45.833333% {stroke: #005992} 50% {stroke: #760033} 79.166667% {stroke: #760033} 83.333333% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w53 {animation: e6UxA3eE01w53_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w53_s_p { 0% {stroke: #005992} 45.833333% {stroke: #005992} 50% {stroke: #760033} 79.166667% {stroke: #760033} 83.333333% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w55 {animation: e6UxA3eE01w55_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w55_s_p { 0% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w56 {animation: e6UxA3eE01w56_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w56_s_p { 0% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w57 {animation: e6UxA3eE01w57_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w57_s_p { 0% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 79.166667% {stroke: #d82071} 83.333333% {stroke: #82d4f2} 87.5% {stroke: #82d4f2} 91.666667% {stroke: #00abe8} 100% {stroke: #00abe8}} #e6UxA3eE01w59 {animation: e6UxA3eE01w59_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w59_f_p { 0% {fill: #00abe8} 12.5% {fill: #00abe8} 16.666667% {fill: none} 37.5% {fill: none} 41.666667% {fill: #d82071} 54.166667% {fill: #d82071} 58.333333% {fill: none} 91.666667% {fill: none} 95.833333% {fill: none} 100% {fill: #00abe8}} #e6UxA3eE01w61 {animation: e6UxA3eE01w61_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w61_s_p { 0% {stroke: #005992} 37.5% {stroke: #005992} 41.666667% {stroke: #760033} 91.666667% {stroke: #760033} 95.833333% {stroke: #760033} 100% {stroke: #005992}} #e6UxA3eE01w62 {animation: e6UxA3eE01w62_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w62_s_p { 0% {stroke: #005992} 37.5% {stroke: #005992} 41.666667% {stroke: #760033} 91.666667% {stroke: #760033} 95.833333% {stroke: #760033} 100% {stroke: #005992}} #e6UxA3eE01w64 {animation: e6UxA3eE01w64_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w64_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}} #e6UxA3eE01w65 {animation: e6UxA3eE01w65_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w65_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}} #e6UxA3eE01w66 {animation: e6UxA3eE01w66_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w66_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 37.5% {stroke: #00abe8} 41.666667% {stroke: #f26aa6} 45.833333% {stroke: #f26aa6} 50% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}} #e6UxA3eE01w68 {animation: e6UxA3eE01w68_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w68_f_p { 0% {fill: #00abe8} 4.166667% {fill: #00abe8} 8.333333% {fill: none} 45.833333% {fill: none} 50% {fill: #d82071} 62.5% {fill: #d82071} 66.666667% {fill: none} 87.5% {fill: none} 91.666667% {fill: #00abe8} 100% {fill: #00abe8}} #e6UxA3eE01w70 {animation: e6UxA3eE01w70_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w70_s_p { 0% {stroke: #005992} 4.166667% {stroke: #005992} 8.333333% {stroke: #005992} 45.833333% {stroke: #005992} 50% {stroke: #760033} 87.5% {stroke: #760033} 91.666667% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w71 {animation: e6UxA3eE01w71_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w71_s_p { 0% {stroke: #005992} 4.166667% {stroke: #005992} 8.333333% {stroke: #005992} 45.833333% {stroke: #005992} 50% {stroke: #760033} 87.5% {stroke: #760033} 91.666667% {stroke: #005992} 100% {stroke: #005992}} #e6UxA3eE01w73 {animation: e6UxA3eE01w73_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w73_s_p { 0% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 83.333333% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w74 {animation: e6UxA3eE01w74_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w74_s_p { 0% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 83.333333% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w75 {animation: e6UxA3eE01w75_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w75_s_p { 0% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 83.333333% {stroke: #d82071} 87.5% {stroke: #d82071} 91.666667% {stroke: #82d4f2} 95.833333% {stroke: #82d4f2} 100% {stroke: #00abe8}} #e6UxA3eE01w77 {animation: e6UxA3eE01w77_f_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w77_f_p { 0% {fill: #00abe8} 12.5% {fill: #00abe8} 16.666667% {fill: none} 45.833333% {fill: none} 50% {fill: #d82071} 62.5% {fill: #d82071} 66.666667% {fill: none} 91.666667% {fill: none} 95.833333% {fill: none} 100% {fill: #00abe8}} #e6UxA3eE01w79 {animation: e6UxA3eE01w79_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w79_s_p { 0% {stroke: #005992} 45.833333% {stroke: #005992} 50% {stroke: #760033} 91.666667% {stroke: #760033} 95.833333% {stroke: #760033} 100% {stroke: #005992}} #e6UxA3eE01w80 {animation: e6UxA3eE01w80_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w80_s_p { 0% {stroke: #005992} 45.833333% {stroke: #005992} 50% {stroke: #760033} 91.666667% {stroke: #760033} 95.833333% {stroke: #760033} 100% {stroke: #005992}} #e6UxA3eE01w82 {animation: e6UxA3eE01w82_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w82_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}} #e6UxA3eE01w83 {animation: e6UxA3eE01w83_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w83_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}} #e6UxA3eE01w84 {animation: e6UxA3eE01w84_s_p 1846.1538461538462ms linear infinite normal forwards}@keyframes e6UxA3eE01w84_s_p { 0% {stroke: #82d4f2} 4.166667% {stroke: #82d4f2} 8.333333% {stroke: #00abe8} 45.833333% {stroke: #00abe8} 50% {stroke: #f26aa6} 54.166667% {stroke: #f26aa6} 58.333333% {stroke: #d82071} 91.666667% {stroke: #d82071} 95.833333% {stroke: #d82071} 100% {stroke: #82d4f2}}`}
      </style>
    </svg>
  )
}
